import React, { useState } from "react";
import "./entries.css";
import Swal from "sweetalert2";
import axios from "axios";

const ManualMeditionModal = ({ master, onClose, onManualAdded }) => {
  const [isClosing, setIsClosing] = useState(false); // para animacion cuando se cierre el modal

  const [formData, setFormData] = useState({
    grossWeight: "",
    grossVolume: "",
    realWeight: "",
    realVolume: "",
  });

  const [errors, setErrors] = useState({
    grossWeight: false,
    grossVolume: false,
    realWeight: false,
    realVolume: false,
  });

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300); // mismo tiempo que la animación (0.3s)
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
    setErrors((prev) => ({ ...prev, [id]: false })); // Limpiar error al escribir
  };

  const handleAccept = async () => {
    const newErrors = {
      grossWeight: !formData.grossWeight,
      grossVolume: !formData.grossVolume,
      realWeight: !formData.realWeight,
      realVolume: !formData.realVolume,
    };

    setErrors(newErrors);

    // const hasErrors = Object.values(newErrors).some(Boolean);
    if (Object.values(newErrors).some(Boolean)) return;

    try {
      const url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/cubiscan/manualMedition`;

      const masterId =
        master?.resp?.id ||
        master?.resp?.master_id ||
        master?.id ||
        master?.master_id;

      const payload = {
        master_id: masterId,
        house_id: null,
        gross_weight: parseFloat(formData.grossWeight),
        gross_volume: parseFloat(formData.grossVolume),
        real_weight: parseFloat(formData.realWeight),
        real_volume: parseFloat(formData.realVolume),
      };

      // const body = {
      //   master_id: masterId,
      //   house_id: null,
      //   gross_weight: parseFloat(formData.grossWeight),
      //   gross_volume: parseFloat(formData.grossVolume),
      //   real_weight: parseFloat(formData.realWeight),
      //   real_volume: parseFloat(formData.realVolume),
      // };

      const res = await axios.post(url, payload, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Medición guardada",
        text: "La medición manual fue registrada correctamente.",
      });

      onManualAdded({
        id_exp_auditor: Date.now(),
        file_name: "Medición manual",
        gross_weight: payload.gross_weight,
        gross_volume: payload.gross_volume,
        real_weight: payload.real_weight,
        real_volume: payload.real_volume,
        medition_type: 2,
        checkedGross: false,
        checkedReal: false,
        hasPallets: false,
      });

      // handleClose();
      onClose();

      // Refrescar CubiscanForm
      // window.location.reload();
    } catch (err) {
      console.error("❌ Error al enviar medición manual:", err);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          err.response?.data?.message ||
          "No se pudo registrar la medición manual.",
      });
    }
  };

  const handleCancel = () => {
    alert("Cancelar");
  };

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 1050,
      }}
    >
      {/* Fondo oscuro */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1040,
        }}
      />
      <div
        className={`modal-dialog modal-lg ${
          isClosing ? "modal-slide-up" : "modal-slide-down"
        }`}
        style={{
          position: "relative",
          zIndex: 1060,
          margin: "5vh auto",
        }}
      >
        <div className="modal-content">
          <div
            className="modal-header"
            style={{
              backgroundColor: "#020C41",
              color: "white",
              padding: "0.5rem 1rem",
            }}
          >
            <h5 className="modal-title m-0">Medición Manual</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={handleClose}
            ></button>
          </div>

          <div className="modal-body container-fluid">
            <div className="row mt-2 mb-3">
              <div className="col-3">
                <label for="grossWeight" class="amc-label">
                  Gross Weight*
                </label>
                <input
                  type="number"
                  class="form-control"
                  id="grossWeight"
                  value={formData.grossWeight}
                  onChange={handleChange}
                />
                {errors.grossWeight && (
                  <div className="text-danger" style={{ fontSize: "0.8rem" }}>
                    Campo obligatorio
                  </div>
                )}
              </div>
              <div className="col-3">
                <label for="grossVolume" class="amc-label">
                  Gross Volume*
                </label>
                <input
                  type="number"
                  class="form-control"
                  id="grossVolume"
                  value={formData.grossVolume}
                  onChange={handleChange}
                />
                {errors.grossVolume && (
                  <div className="text-danger" style={{ fontSize: "0.8rem" }}>
                    Campo obligatorio
                  </div>
                )}
              </div>
              <div className="col-3">
                <label for="realWeight" class="amc-label">
                  Real Weight*
                </label>
                <input
                  type="number"
                  class="form-control"
                  id="realWeight"
                  value={formData.realWeight}
                  onChange={handleChange}
                />
                {errors.realWeight && (
                  <div className="text-danger" style={{ fontSize: "0.8rem" }}>
                    Campo obligatorio
                  </div>
                )}
              </div>
              <div className="col-3">
                <label for="realVolume" class="amc-label">
                  Real Volume*
                </label>
                <input
                  type="number"
                  class="form-control"
                  id="realVolume"
                  value={formData.realVolume}
                  onChange={handleChange}
                />
                {errors.realVolume && (
                  <div className="text-danger" style={{ fontSize: "0.8rem" }}>
                    Campo obligatorio
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col mt-2 d-flex justify-content-end gap-2">
                <button className="btnn" onClick={handleClose}>
                  Cancelar
                </button>
                <button className="btnn" onClick={handleAccept}>
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualMeditionModal;
